import { getTrustedCompanies, TRUSTED_BY_SECTION } from "../data/home-data";

export default function TrustedBy({ country }) {
  const logos = getTrustedCompanies(country);

  return (
    <section className="py-16 border-y border-gray-100 bg-white" data-testid="trusted-by-section">
      <div className="max-w-7xl mx-auto px-4">
        <p className="text-center text-xs uppercase tracking-[0.3em] text-gray-400 mb-8 font-semibold">{TRUSTED_BY_SECTION.tagline}</p>
        <div className="overflow-hidden relative">
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
          <div className="flex hp-marquee gap-16 items-center whitespace-nowrap">
            {[...logos, ...logos].map((company, i) => (
              <div key={i} className="flex items-center justify-center h-12 ">
                <img
                  src={company.logo}
                  alt={company.name}
                  className="h-10 w-auto object-contain"
                  style={{ maxWidth: '140px' }}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
